import USPBanner from '@finn/auto-ui/components/USPBanner';
import { USPBannerData } from '@finn/ui-cosmic';
import React, { useEffect, useState } from 'react';

import useGetContentPieces from '~/components/ProductListingPage/useGetContentPieces';
import useOnPLPMount from '~/components/ProductListingPage/useOnPLPMount';
import PromoBanner from '~/components/PromoBanner';
import { PLPPageData } from '~/types/cosmicModules';

type Props = {
  pageData: PLPPageData;
  uspBanner: USPBannerData;
  mt?: boolean;
};

const PLPBanners: React.FC<Props> = ({ pageData, uspBanner, mt }) => {
  const [isMounted, setIsMounted] = useState(false);
  const { isRedirectedPageNotExist } = useOnPLPMount();
  const { shouldRenderPromoSection } = useGetContentPieces({
    pageData,
    isRedirectedPageNotExist,
  });

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return;

  return (
    <>
      {mt && <div style={{ marginTop: '20px' }} />}

      {/* @TODO - We Have adopted the top campaign banner to
        we may want to remove this in the future
       */}
      {shouldRenderPromoSection && <PromoBanner pageData={pageData} />}

      {uspBanner && <USPBanner data={uspBanner} />}
    </>
  );
};
export default PLPBanners;
